/**
 * Zentrale Registry aller Feature-Flag-Keys.
 * Neue Flags werden per Migration eingefügt und hier als Konstante ergänzt,
 * damit Guards und Hooks typsicher darauf zugreifen.
 */
export const FEATURE_FLAGS = {
  cockpitPublicVisible: "cockpit_public_visible",
  /** Ticket Z13: Hinweisseite zur TTPA-Verordnung im Modul „100 Tage im Amt". */
  moduleTtpaInfoVisible: "module_ttpa_info_visible",
  /** Ticket SK2: Kaufstrecke über Stripe. Standardmäßig geschlossen. */
  checkoutStripeEnabled: "checkout_stripe_enabled",
  /**
   * Ticket ME1: Bereich „Mentorings" unter Wissen. Solange der Schalter zu ist,
   * fehlt der Menüeintrag, die Seiten stehen nicht in der Sitemap und sind ohne
   * Anmeldung nicht erreichbar.
   */
  mentoringsVisible: "mentorings_visible",
  /**
   * Ticket KN1: Bereich „Keynotes" unter Wissen. Eigener Schalter, getrennt von
   * dem der Mentorings. Solange er zu ist, fehlt der Menüeintrag, die Seite
   * steht nicht in der Sitemap und ist ohne Anmeldung nicht erreichbar.
   */
  keynotesVisible: "keynotes_visible",
  /**
   * Schwebender WhatsApp-Button „Kurze Frage?“. Fehlt der Eintrag, gilt er als
   * eingeschaltet (der Button war vor dem Schalter bereits live).
   */
  whatsappButtonVisible: "whatsapp_button_visible",
} as const;

export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
